module.exports = __webpack_public_path__ + "static/media/profilePic2.1.a251fcbb.jpg";